export const isDefined = <Type>(
  param: Type | undefined | null
): param is Type => param !== null && param !== undefined;
